import { useMantineColorScheme } from "@mantine/core"

import { getMetricLabelWithCurrency } from "@costory/shared/utils/format"

import { useBusinessMetricsQuery } from "@costory/front/queries/businessMetrics"

export type NumberType = "decimal" | "currency" | "percent"

export const useYAxisLabelConfig = (metricId: string, currency?: string) => {
  const { colorScheme } = useMantineColorScheme()
  const { data } = useBusinessMetricsQuery()
  return {
    value: getMetricLabelWithCurrency(metricId, data, currency),
    position: "insideLeft",
    angle: 90,
    style: {
      fill: colorScheme === "dark" ? "#fff" : "#000",
      fontSize: 14,
      textAnchor: "middle",
    },
  }
}
